import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { techPreferenceOptions } from './schema';

export function TechPreferenceInput({ isEditable }: { isEditable?: boolean }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="tech_preference"
      render={({ field: { value, onChange } }) => (
        <FormSelect
          disabled={!isEditable}
          value={value}
          getOptionLabel={(option) => option.name}
          onChange={onChange}
          options={techPreferenceOptions}
          label="Tech Preference"
        />
      )}
    />
  );
}
